<template lang="pug">
  div.alert.alert-warning(role='alert' v-if="message") {{ message }}
</template>

<script>
export default {
  props: ['message'],
};
</script>

<style scoped>
.alert-warning {
  margin-top: 10px;
}
</style>
